<template>
    <span v-if="payments.length === 0">No payments.</span>

    <DataTable :value="payments" v-else class="p-datatable-sm row-click" responsiveLayout="stack" stripedRows dataKey="id"
        id="payments-table" :rowClass="() => { return 'table-row' }" @row-click="(e) => openPrintPaymentReceipt(e.data.id)"
        :paginator="true" :rows="20" :rowsPerPageOptions="[10, 20, 50, 100]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        paginatorPosition="both" currentPageReportTemplate="({first} - {last} of {totalRecords})">
        <Column field="id" header="Id">
            <template #body="slotProps">
                {{ slotProps.data.id }}
            </template>
        </Column>
        <Column field="transaction_date" header="Date">
            <template #body="slotProps">
                {{ moment(slotProps.data.transaction_date).format('M/D/YY h:mm A') }}
            </template>
        </Column>
        <Column field="id" header="Payment">
            <template #body="slotProps">
                <PaymentType class="ml-2" :payment="slotProps.data" />
            </template>
        </Column>
        <Column class="table-right" field="order_id" header="Order ID" headerClass="header-right">
            <template #body="slotProps">
                <a v-if="slotProps.data.order_id" :href="route('mtd.order.view', slotProps.data.order_id)">{{
                    slotProps.data.order_id }}</a>
            </template>
        </Column>
        <Column class="table-right" field="user_shipment_id" header="Shipment ID" headerClass="header-right">
            <template #body="slotProps">
                <a v-if="slotProps.data.user_shipment_id" :href="route('shipments.show', slotProps.data.user_shipment_id)">
                    {{ slotProps.data.user_shipment_id }}
                </a>
            </template>
        </Column>
        <Column class="table-right" field="amount" header="Payment Amount" headerClass="header-right">
            <template #body="slotProps">
                <span :class="{ 'text-danger': (slotProps.data.amount < 0) }"></span> {{ slotProps.data.amount < 0 ? '-'
                    : '' }}{{ formatDollars(Math.abs(slotProps.data.amount)) }} </template>
        </Column>
    </DataTable>
    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="printPaymentReceipt" />
    </teleport>
</template>

<script>
import moment from 'moment'
import PaymentType from '@/Components/Transaction/PaymentType'
import PrintModal from '@/Components/Modals/PrintModal'

export default {
    data() {
        return {
            selectedReceiptPaymentId: null,
            printUrl: '',
        }
    },
    props: {
        payments: Array
    },
    components: {
        PaymentType,
        PrintModal,
    },
    methods: {
        openPrintPaymentReceipt(paymentId) {
            this.selectedReceiptPaymentId = paymentId
            this.printUrl = this.route('tu.payment.receipt', this.selectedReceiptPaymentId);
            $('#PrintModal').modal('show');
        },
        printPaymentReceipt() {
            this.printUrl = this.route('tu.payment.receipt', { payment: this.selectedReceiptPaymentId, print: 1 });
        },
    },
    mounted() {
        console.log(this.payments)
    },
    created() {
        this.moment = moment
    }
}
</script>

<style>
#payments-table .p-datatable-wrapper {
    margin-bottom: 1rem;
    margin-top: 1rem;
}
</style>
